module.exports = __webpack_public_path__ + "static/media/logo.565490e7.png";